import PropTypes from "prop-types";
import { Button, Stack } from "@mui/material";

const ui = {
  pageBg: "#f7f8fa",
  panel: "#ffffff",
  railBg: "#ffffff",
  border: "#e6e9ee",
  borderStrong: "#d9dee7",
  text: "#182230",
  muted: "#667085",
  subtle: "#98a2b3",
  soft: "#f8fafc",
  successBg: "#eefaf2",
  successBorder: "#b7e4c4",
  successText: "#17733b",
};

const ChoiceGroup = ({ value, onChange, disabled, options }) => (
  <Stack
    direction="row"
    spacing={0}
    sx={{
      width: "100%",
      border: `1px solid ${ui.borderStrong}`,
      borderRadius: 0.7,
      overflow: "hidden",
      bgcolor: "#fff",
    }}
  >
    {options.map((option, index) => {
      const selected = value === option.value;
      const success = selected && option.tone === "success";

      return (
        <Button
          key={option.value}
          disabled={disabled}
          onClick={() => onChange(option.value)}
          sx={{
            flex: 1,
            minWidth: 0,
            minHeight: { xs: 40, sm: 34 },
            px: 0.7,
            borderRadius: 0,
            borderLeft: index ? `1px solid ${ui.borderStrong}` : "none",
            bgcolor: success ? ui.successBg : selected ? ui.soft : "#fff",
            color: success ? ui.successText : selected ? ui.text : ui.muted,
            boxShadow: success ? `inset 0 0 0 1px ${ui.successBorder}` : "none",
            fontSize: 11.8,
            fontWeight: selected ? 700 : 600,
            textTransform: "none",
            gap: 0.45,
            "&:hover": {
              bgcolor: success ? ui.successBg : selected ? ui.soft : "#fafafa",
            },
            "& .MuiSvgIcon-root": {
              fontSize: 14,
              color: success ? ui.successText : "inherit",
            },
          }}
        >
          {option.icon}
          {option.label}
        </Button>
      );
    })}
  </Stack>
);

ChoiceGroup.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      icon: PropTypes.node,
      tone: PropTypes.oneOf(["default", "success"]),
    })
  ).isRequired,
};

ChoiceGroup.displayName = "ChoiceGroup";

export default ChoiceGroup;
